import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { PageEvent } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";

import { ActionDialog, BaseComponent, LoadingTeste } from "app/base-module/base-component/base.component";
import { AuthService } from "app/base-module/base-service/auth.service";
import { CadastroRelacionamentoClienteComponent } from "app/clientes/cadastro-relacionamento-cliente/cadastro-relacionamento-cliente.component";
import { ClienteService } from "app/clientes/services/cliente.service";
import { IItemsPermissionActions } from "app/interfaces/IItemsPermissionActions";
import { UserRoleEnum } from "app/usuarios/models/user-role.enum";
import { Usuario } from "app/usuarios/models/user.model";

import { CadastraAtividadeClientesComponent } from "../cadastra-atividade-clientes/cadastra-atividade-clientes.component";
import { FiltroAtividadesComponent } from "../filtro-atividades/filtro-atividades.component";
import { ResponderAtividadeComponent } from "../responder-atividade/responder-atividade.component";
import { RespostaAtividadeComponent } from "../resposta-atividade/resposta-atividade.component";
import { RespostaTarefaEspecialistaComponent } from "../resposta-tarefa-especialista/resposta-tarefa-especialista.component";
import { ListaAtividadeClienteService } from "../services/lista-atividade-clientes.service";
import { UploadTarefasArquivosComponent } from "../upload-tarefas-arquivos/upload-tarefas-arquivos.component";

interface Actions {
    buttonNew: IItemsPermissionActions;
    buttonView: IItemsPermissionActions;
    buttonEdit: IItemsPermissionActions;
    buttonDelete: IItemsPermissionActions;
    buttonExport: IItemsPermissionActions;
    buttonListFiles: IItemsPermissionActions;
    buttonNewFiles: IItemsPermissionActions;
    buttonDeleteFiles: IItemsPermissionActions;
    buttonDownloadFiles: IItemsPermissionActions;
}

@Component({
    selector: "lista-todas-atividades",
    templateUrl: "./lista-todas-atividades.component.html",
    styleUrls: ["./lista-todas-atividades.component.scss"],
    providers: [ClienteService],
})
export class ListaTodasAtividadesComponent extends BaseComponent implements OnInit {
    usuario: Usuario;
    search = new FormControl("");
    inputSubscription!: Subscription;
    isFiltered: boolean = false;
    is_priority: boolean = false;
    length_priority: number = 0;
    all_month: boolean = false;
    is_especialista: boolean = false;
    is_assessor: boolean = false;
    sortDirection: "asc" | "desc" = "asc";
    currentSortColumn: string = "";

    readonly UserRole = UserRoleEnum;

    _actions: Actions = {
        buttonNew: {
            permission: "Cadastrar Atividade da Lista de Atividades",
            enabled: false,
        },
        buttonView: {
            permission: "Visualizar Atividade da Lista de Atividades",
            enabled: false,
        },
        buttonEdit: {
            permission: "Editar Atividade da Lista de Atividades",
            enabled: false,
        },
        buttonDelete: {
            permission: "Excluir Atividade da Lista de Atividades",
            enabled: false,
        },
        buttonExport: {
            permission: "Exportar Atividade da Lista de Atividades",
            enabled: false,
        },
        buttonListFiles: {
            permission: "Listar Arquivos da Lista de Atividades",
            enabled: false,
        },
        buttonNewFiles: {
            permission: "Cadastrar Arquivos da Lista de Atividades",
            enabled: false,
        },
        buttonDeleteFiles: {
            permission: "Excluir Arquivos da Lista de Atividades",
            enabled: false,
        },
        buttonDownloadFiles: {
            permission: "Download de Arquivos da Lista de Atividades",
            enabled: false,
        },
    };
    loadingLocal: any;

    @ViewChild("addButtonTmpl", { static: false }) addButtonTmpl!: TemplateRef<any>;
    @ViewChild(ListaTodasAtividadesComponent, { static: false }) table!: ListaTodasAtividadesComponent;

    constructor(
        public _service: ListaAtividadeClienteService,
        public dialog: MatDialog,
        override snackBar: MatSnackBar,
        public _authService: AuthService,
        public route: Router,
        public router: ActivatedRoute,
        private loading: MatDialog
    ) {
        super(dialog, snackBar);
        this.verifyPermissionForActions();

        const strUser = this._authService.getUser();
        this.usuario = JSON.parse(strUser ? strUser : "{}");
    }

    displayedColumns: string[] = [];

    ngOnInit(): void {
        this.router.data.subscribe((data) => {
            this.is_assessor = data["is_assessor"];
        });

        this.resetParamsFilters();

        this.displayedColumns = this.columns = [
            "data_hora_atividade",
            "cliente_nome",
            "nome_assunto",
            "valor_sugerido",
            "observacao",
            "registro_contato",
            "arquivos",
            "acao",
        ];

        // Adiciona a coluna 'nome_assessor' apenas se role_id for diferente de 5
        if (this.usuario.role_id !== 5) {
            this.displayedColumns.splice(1, 0, "nome_assessor"); // Nome do acessor
        }

        if (!this.is_assessor) {
            this.displayedColumns.splice(3, 0, "especialista"); // Nome do especialista
            this.displayedColumns.splice(7, 0, "servico"); // Nome do especialista
        }

        this.getAll();

        if (this.usuario.grupo_especialista_id) this.is_especialista = true;
    }

    resetParamsFilters() {
        this.params = {};
        this.params.hoje_futuro = true;
        this.params.is_assessor = this.is_assessor;
        this.params.atividade_concluidas = "false";
        this.all_month = true;
        this.is_priority = false;
        this.isFiltered = false;
    }

    /**
     * Evento de ordenação da lista de produtos
     * @param event
     */
    onSort(column: string) {
        this.params.sortColumn = column;
        if (this.currentSortColumn === column) {
            this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
        } else {
            this.currentSortColumn = column;
            this.sortDirection = "asc";
        }
        this.params.sortOrder = this.sortDirection;
        this.getAll();
    }

    /**
     * Evento da paginação
     * @param {PageEvent} event
     */

    pageEvent(event: PageEvent) {
        this.params.page = event.pageIndex + 1;
        this.params.per_page = event.pageSize;

        this.getAll();
    }

    verifyPermissionForActions() {
        this._actions.buttonDelete.enabled = this._authService.isPermissao([this._actions.buttonDelete.permission]);

        this._actions.buttonEdit.enabled = this._authService.isPermissao([this._actions.buttonEdit.permission]);

        this._actions.buttonView.enabled = this._authService.isPermissao([this._actions.buttonView.permission]);

        this._actions.buttonNew.enabled = this._authService.isPermissao([this._actions.buttonNew.permission]);

        this._actions.buttonExport.enabled = this._authService.isPermissao([this._actions.buttonExport.permission]);

        this._actions.buttonListFiles.enabled = this._authService.isPermissao([
            this._actions.buttonListFiles.permission,
        ]);
    }

    /**
     * Abre loagind
     */
    openLoadingLocal(): void {
        this.loadingLocal = this.loading.open(LoadingTeste, {
            width: "150px",
            disableClose: true,
        });
    }

    /**
     * Fecha loagind
     */
    closeLoadingLocal(): void {
        if (this.loadingLocal != null) {
            this.loadingLocal.close();
        }
    }

    /**
     * Consulta lista de empresas
     */
    getAll() {
        this.openLoadingLocal();
        this.params.is_priority = this.is_priority;
        this.params.all_month = this.all_month;
        this._service.getAll(this.params).subscribe(
            (data) => {
                this.length = data.meta.total;
                this.rows = data.data;
                if (this.is_priority) {
                    this.length_priority = data.meta.total;
                }
            },
            (error) => {
                this.closeLoadingLocal();
                this.showError(error.error.message);
            },
            () => {
                this.closeLoadingLocal();
            }
        );

        if (this.is_assessor && !this.is_priority && this.params.page === undefined) {
            this._service.getAll({ ...this.params, is_priority: true }).subscribe((data) => {
                this.length_priority = data.meta.total;
            });
        }
    }

    /**
     * Modal de cadastro
     */
    openCadastro(): void {
        const dialogRef = this.dialog.open(CadastraAtividadeClientesComponent, {
            width: "700px",
            maxHeight: "99vh",
            data: {
                is_assessor: this.is_assessor,
            },
        });

        dialogRef.afterClosed().subscribe((result: any) => {
            if (result != undefined && result != null && result != "cancel") {
                this.showSuccess("Atividade cadastrado com sucesso!");
                this.getAll();
            } else if (result != undefined && result != "cancel") {
                this.showError("Ocorreu um erro ao tentar cadastrar um novo registro.");
            }
        });
    }

    /**
     * Modal de edição
     */
    openAlterar(id: number): void {
        const dialogRef = this.dialog.open(CadastraAtividadeClientesComponent, {
            width: "700px",
            maxHeight: "99vh",
            data: { id: id, is_alterar_data: true, is_assessor: this.is_assessor },
        });

        dialogRef.afterClosed().subscribe((result: any) => {
            if (result != undefined && result != null && result != "cancel") {
                this.showSuccess("Atividade atualizada com sucesso!");
                this.getAll();
            } else if (result != undefined && result != "cancel") {
                this.showError("Ocorreu um erro ao tentar altera o registro");
            }
        });
    }

    /**
     *
     * @param id
     */
    delete(id: number) {
        const lista = this;
        this.dialog.open(ActionDialog, {
            width: "250px",
            disableClose: true,
            panelClass: "modal-delete",
            data: {
                title: "Excluir Atividade",
                text: "Deseja realmente excluir este item?",
                callback: function () {
                    lista.dialog.closeAll();

                    lista.openLoadingLocal();
                    lista._service.delete(id).subscribe(
                        (data) => {
                            lista.closeLoadingLocal();
                            lista.showSuccess(data.message);
                            lista.getAll();
                        },
                        (error) => {
                            lista.closeLoadingLocal();
                            console.log("error: " + error);
                            lista.showError(error.message);
                        },
                        () => {
                            lista.closeLoadingLocal();
                        }
                    );
                },
            },
        });
    }

    /**
     * Modal de Filtro
     */
    openFiltro(): void {
        const dialogRef = this.dialog.open(FiltroAtividadesComponent, {
            width: "700px",
            maxHeight: "99vh",
            data: this.params,
        });

        dialogRef.afterClosed().subscribe((result: any) => {
            if (result != "cancel" && result != undefined) {
                if (result.data_operacao_inicio != undefined && result.data_operacao_inicio != null) {
                    this.params.data_operacao_inicio = result.data_operacao_inicio;
                    this.params.data_operacao_fim = result.data_operacao_fim;
                    this.params.hoje_futuro = false;
                } else {
                    this.params.hoje_futuro = true;
                }

                if (result.cliente != undefined && result.cliente != null) {
                    this.params.cliente_id = result.cliente.id;
                }

                if (result.escritorio_id != undefined && result.escritorio_id != null) {
                    this.params.escritorio_id = result.escritorio_id;
                }

                if (result.assessor_id != undefined && result.assessor_id != null) {
                    this.params.assessor_id = result.assessor_id;
                }

                if (result.especialista_id != undefined && result.especialista_id != null) {
                    this.params.especialista_id = result.especialista_id;
                }

                if (result.assunto_id != undefined && result.assunto_id != null) {
                    this.params.assunto_id = result.assunto_id;
                }

                if (result.servico_id != undefined && result.servico_id != null) {
                    this.params.servico_id = result.servico_id;
                }

                if (result.atividade_concluidas != undefined && result.atividade_concluidas != null) {
                    this.params.atividade_concluidas = result.atividade_concluidas;
                }

                this.paginator.firstPage();
                this.all_month = false;
                this.isFiltered = true;

                this.getAll();
            }
        });
    }

    /**
     * Consulta lista
     */
    getAllExport() {
        this.openLoading();
        this._service.getAllExport(this.params).subscribe(
            (data) => {
                const blob = new Blob([data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
                const url = window.URL.createObjectURL(blob);
                window.open(url, "_blank");
            },
            (error) => {
                this.showError(error.error.message);
                this.closeLoading();
            },
            () => {
                this.closeLoading();
            }
        );
    }

    togglePriority(): void {
        this.is_priority = !this.is_priority;
        this.params.page = 1;
        this.getAll();
    }

    redirecionaCliente(clienteId: any) {
        // Algumas atividades nao tem cliente vinculado; evita crash e
        // navegacao para /clientes/cadastro/undefined/painel.
        if (clienteId == null) {
            return;
        }
        this.route.navigate([`clientes/cadastro/${clienteId}/painel`]);
    }

    onActivate(row: any) {
        this.openLoadingLocal();

        const atividade = {
            visualizado: true,
            atividade_id: row.atividade_id,
            cliente_id: row.cliente_id,
        };

        this._service.update(row.id, atividade).subscribe(
            (data) => {
                this.getAll();
            },
            (error) => {
                this.closeLoadingLocal();
                this.showError(error.error.message);
            },
            () => {}
        );
    }

    openRegistroContato(row: any) {
        const dialogRef = this.dialog.open(CadastroRelacionamentoClienteComponent, {
            width: "1200px",
            maxHeight: "99vh",
            data: {
                id: row.id,
                cliente_id: row.cliente_id,
                dados_cliente: row.cliente,
                cliente: true,
                only_show: false,
                atividade_cliente_id: row.id,
                nome_assunto: row.nome_assunto,
                valor: row.valor,
                is_assessor: this.is_assessor,
                user_id: this.usuario.id,
                servico_id: row.servico_id,
                assunto_id: row.assunto_id,
                resposta: row.resposta,
            },
        });

        dialogRef.afterClosed().subscribe((result: any) => {
            if (result != undefined && result != null && result != "cancel") {
                this.showSuccess("Relacionamento Cadastrado com Sucesso!");
            } else if (result != undefined && result != "cancel") {
                this.showError("Ocorreu um erro ao tentar cadastrar o registro");
            }

            this.getAll();
        });
    }

    openRespostaEspecialista(row: any) {
        const dialogRef = this.dialog.open(RespostaTarefaEspecialistaComponent, {
            width: "1000px",
            maxHeight: "99vh",
            data: { ...row },
        });

        dialogRef.afterClosed().subscribe(() => {
            this.getAll();
        });
    }

    openResposta(row: any) {
        this.dialog.open(RespostaAtividadeComponent, {
            width: "500px",
            data: {
                cliente_aceitou: row.cliente_aceitou,
                data_resposta: row.updated_at,
                observacao: row.observacao,
                valor: row.valor,
                assunto: row.nome_assunto,
                is_assessor: this.is_assessor,
            },
        });
    }

    openResponderAtividade(row: any) {
        const dialogRef = this.dialog.open(ResponderAtividadeComponent, {
            width: "1200px",
            maxHeight: "99vh",
            data: {
                id: row.id,
                cliente_aceitou: row.cliente_aceitou,
                data_resposta: row.data_resposta,
                observacao: row.observacao,
                valor: row.valor,
                is_assessor: this.is_assessor,
            },
        });

        dialogRef.afterClosed().subscribe((result: any) => {
            if (result != undefined && result != null && result != "cancel") {
                this.dorecionaRegistroContato(row);
                this.getAll();
            } else if (result != undefined && result != "cancel") {
                this.showError("Ocorreu um erro ao tentar cadastrar a resposta");
            }
        });
    }

    dorecionaRegistroContato(row: any) {
        const lista = this;
        this.dialog.open(ActionDialog, {
            width: "500px",
            disableClose: true,
            data: {
                title: "Resposta cadastrada com sucesso!",
                text: "Deseja adicionar um novo contato com cliente?",
                callback: function () {
                    lista.openRegistroContato(row);
                },
            },
        });
    }

    onEnter(value: string) {
        this.stopNow();
        this.params.search = value;
        this.search.setValue(value);
        this.getAll();
        this.isFiltered = true;
    }

    stopNow() {
        if (this.inputSubscription) {
            this.inputSubscription.unsubscribe();
        }
    }

    resetFilters() {
        this.resetParamsFilters();
        this.getAll();
    }

    exportar() {
        this.openLoading();
        this._service.getAllExport(this.params).subscribe(
            (data) => {
                const blob = new Blob([data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
                const url = window.URL.createObjectURL(blob);
                window.open(url, "_blank");
            },
            (error) => {
                this.closeLoading();
            },
            () => {
                this.closeLoading();
            }
        );
    }

    canRespond(row: any): boolean {
        if (this._actions.buttonEdit.enabled) {
            if (!row.resposta && this.is_assessor === true) {
                return true;
            }
            if (!row.resposta_especialista && this.is_assessor === false) {
                return true;
            }
        }
        return false;
    }

    /**
     * Modal de cadastro
     */
    openViewFiles(row: any): void {
        this.dialog.open(UploadTarefasArquivosComponent, {
            width: "700px",
            maxHeight: "99vh",
            data: {
                id: row.id,
            },
        });
    }
}
